export default __webpack_public_path__ + "static/media/book-nav-icon7-completed.8f537dd2.svg";